import { medalLandscape } from "./medal-landscape.js";
export const WEEKEND_AWARD = {
    id: "weekend-winner",
    kind: "weekend",
    title: "Weekend winner",
    collection: "Weekend challenges",
    description: "A little extra movement. A weekend to remember.",
    requirement: "Finish first in the company weekend standings once results are final.",
    status: "preview",
    progress: null,
    remainingMeters: null,
    ordinal: 1,
    routeInstanceId: null,
};
/**
 * Current-route achievement previews, derived from server progress. These are
 * not permanent grants. Reached dates come only from server step history.
 */
export function routeAwards(route, enrollment, history = [], options = {}) {
    if (!route)
        return [];
    const unwalked = options.joinable === false ? "preview" : "available";
    const member = enrollment?.instanceId === route.instanceId ? enrollment : null;
    const fraction = member && member.target > 0 ? member.progress / member.target : 0;
    const milestones = route.routeMilestones
        .map((milestone, index) => ({ ...milestone, index }))
        .filter((milestone) => milestone.fraction > 0)
        .sort((a, b) => a.fraction - b.fraction);
    const makeAward = (kind, threshold, title, description, ordinal, key, milestoneIndex) => {
        const progress = Math.max(0, Math.min(1, fraction / threshold));
        return {
            id: `${route.instanceId}-${key}`,
            kind,
            landscape: medalLandscape(route.name, kind === "completion" ? null : title),
            title,
            collection: route.name,
            description,
            requirement: kind === "completion" ? `Complete ${route.name}.` : `Reach ${title} on ${route.name}.`,
            status: !member ? unwalked : progress >= 1 ? "reached" : "in-progress",
            progress,
            remainingMeters: member && route.distanceMeters
                ? Math.max(0, (threshold - fraction) * route.distanceMeters)
                : null,
            ordinal,
            routeInstanceId: route.instanceId,
            reached: member && progress >= 1
                ? history.find((item) => item.kind === kind && item.milestoneIndex === milestoneIndex)
                : undefined,
        };
    };
    return [
        ...milestones.map((milestone, index) => makeAward("waypoint", milestone.fraction, milestone.title, milestone.description, index + 1, `waypoint-${milestone.index}`, milestone.index)),
        makeAward("completion", 1, route.name, "The whole route, one ordinary day of movement at a time.", 0, "completion", Math.max(0, route.routeMilestones.length - 1)),
    ];
}
export function awardStatusLabel(award) {
    if (award.kind === "streak") {
        if (!award.streak)
            return "Levels: 5, 10, 20, 50 days";
        return award.streak.earnedDays
            ? `Level ${award.streak.level} · ${award.streak.earnedDays} days`
            : award.streak.current > 0
                ? `${award.streak.current} of 5 days`
                : "Your first level awaits";
    }
    switch (award.status) {
        case "reached":
            return award.kind === "completion" ? "Route complete" : "Waypoint reached";
        case "available":
            return "Join to begin";
        case "preview":
            return "Award preview";
        case "in-progress":
            return `${Math.floor((award.progress ?? 0) * 100)}% of the way`;
    }
}
//# sourceMappingURL=award-model.js.map